import { createComponent } from '@carvana/merch-components';

export const Card = createComponent('div', {
  className: 'flex flex-col gap-32'
});

export const ContentSection = createComponent('div', {
  className: 'flex flex-col gap-24'
});

export const Headline = createComponent('h2', {
  className: 'text-text-strong t-brand-sm sm:t-brand-md md:t-brand-lg m-0'
});

export const TaskWarning = createComponent('div', {
  className: 'flex flex-row items-center gap-md'
});

export const BodyText = createComponent('p', {
  className: 'text-text-default t-body-sm m-0 max-w-[440px]'
});

export const VehicleSection = createComponent('div', {
  className: 'flex flex-col gap-24'
});

export const VehicleInfo = createComponent('div', {
  className: 'flex flex-col gap-4'
});

export const VehicleTitle = createComponent('p', {
  className: 'text-text-strong t-heading-md m-0'
});

export const VehicleSubText = createComponent('div', {
  className:
    'flex flex-row flex-wrap items-center gap-8 text-text-strong t-body-sm'
});
